import { environment } from 'src/environments/environment';

// Two-layer flag: runtime localStorage override wins; otherwise build-time default.
// Sprint 3 ships build-default OFF and engineers opt in via localStorage.
export function isCognitoEnabled(): boolean {
  try {
    const override = localStorage.getItem('useCognito');
    if (override === '1') return true;
    if (override === '0') return false;
  } catch {
    /* localStorage unavailable (private browsing, SSR shim) */
  }
  return environment.featureFlags.useCognito;
}
